import { apiRequest } from "./api";
import type {
  AuthUserResponseDto,
  DeleteAccountRequestDto,
  RequestEmailChangeRequestDto,
  UpdateAccountProfileRequestDto,
  UpdatePhoneNumberRequestDto,
  UserNotificationListResponseDto,
  UserNotificationSummaryResponseDto,
  UserNotificationViewDto,
  VerifyPhoneNumberRequestDto,
} from "../types/types";

export const accountApi = {
  updateProfile(payload: UpdateAccountProfileRequestDto): Promise<AuthUserResponseDto> {
    return apiRequest<AuthUserResponseDto>("/api/account/profile", {
      method: "PATCH",
      body: payload,
    });
  },

  requestEmailChange(payload: RequestEmailChangeRequestDto): Promise<AuthUserResponseDto> {
    return apiRequest<AuthUserResponseDto>("/api/account/email/change-request", {
      method: "POST",
      body: payload,
    });
  },

  updatePhoneNumber(payload: UpdatePhoneNumberRequestDto): Promise<AuthUserResponseDto> {
    return apiRequest<AuthUserResponseDto>("/api/account/phone", {
      method: "POST",
      body: payload,
    });
  },

  resendPhoneVerificationCode(): Promise<void> {
    return apiRequest<void>("/api/account/phone/resend", {
      method: "POST",
    });
  },

  verifyPhoneNumber(payload: VerifyPhoneNumberRequestDto): Promise<AuthUserResponseDto> {
    return apiRequest<AuthUserResponseDto>("/api/account/phone/verify", {
      method: "POST",
      body: payload,
    });
  },

  deleteAccount(payload: DeleteAccountRequestDto): Promise<void> {
    return apiRequest<void>("/api/account", {
      method: "DELETE",
      body: payload,
    });
  },

  listNotifications(params: { view: UserNotificationViewDto; page: number; size: number }): Promise<UserNotificationListResponseDto> {
    const searchParams = new URLSearchParams({
      view: params.view,
      page: String(params.page),
      size: String(params.size),
    });
    return apiRequest<UserNotificationListResponseDto>(`/api/account/notifications?${searchParams.toString()}`, {
      method: "GET",
    });
  },

  getNotificationSummary(): Promise<UserNotificationSummaryResponseDto> {
    return apiRequest<UserNotificationSummaryResponseDto>("/api/account/notifications/summary", {
      method: "GET",
    });
  },

  markNotificationRead(notificationId: string): Promise<void> {
    return apiRequest<void>(`/api/account/notifications/${notificationId}/read`, {
      method: "POST",
    });
  },

  archiveNotification(notificationId: string): Promise<void> {
    return apiRequest<void>(`/api/account/notifications/${notificationId}/archive`, {
      method: "POST",
    });
  },

  markAllNotificationsRead(view?: UserNotificationViewDto): Promise<void> {
    const suffix = view ? `?view=${encodeURIComponent(view)}` : "";
    return apiRequest<void>(`/api/account/notifications/read-all${suffix}`, {
      method: "POST",
    });
  },

  archiveAllRecentUpdates(): Promise<void> {
    return apiRequest<void>("/api/account/notifications/recent-updates/archive-all", {
      method: "POST",
    });
  },

  completeInstallAppReminder(): Promise<void> {
    return apiRequest<void>("/api/account/notifications/install-app/complete", {
      method: "POST",
    });
  },
};
